const initialState = {
  filters: {
    isUpdated: false,
    isCleared: true,
    options: {
      location: { cleared: true },
      uploadedBy: { cleared: true },
      uploadedDate: {
        cleared: true,
        from: { value: null, label: null },
        to: { value: null, label: null },
      },
      workstream: { cleared: true },
      task: { cleared: true },
      comment: { cleared: true },
      name: null,
    },
  },
  access: {
    init: false,
    role: null,
    members: [],
    isLibraryEnabled: null,
  },
  modal: {
    fileUpload: false,
    minimizeUpload: false,
  },
  Actions: {
    add: {},
    reply: {},
    update: {},
  },
  libraryAccess: 'viewer',
  sorting: { column: 'uploadDate', order: 'desc' },
  updateLibraryAccess: false,
  selected: {},
  list: [],
  fileCount: 0,
  folders: [],
  folder: null,
  enableUpdate: 'false',
  folderCount: 0,
  subfolders: {},
  activeFolder: 'null',
  activeInSidebar: { id: null, label: null },
  tempFiles: { status: null, files: [], cancelToken: null },
  actionItem: '',
  comments: [],
  fileComment: '',
  viewer: {
    action: null,
    isFullscreen: false,
  },
  selectedBreadcrumb: 'null',
  showDeleteModal: false,
  selectedItems: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_FILES_VIEWER':
      return {
        ...state,
        viewer: {
          ...state.viewer,
          ...action.data,
        },
      };

    case 'UPDATE_FILES_VIEWER_FULLSCREEN':
      return {
        ...state,
        viewer: {
          ...state.viewer,
          isFullscreen: action.value,
        },
      };

    case 'UPDATE_FILES_SORTING':
      return {
        ...state,
        sorting: action.sorting,
      };

    case 'UPDATE_FILES_COMMENTS':
      let comments = state.comments;

      for (const item of action.comments) {
        const updateIndex = _.findIndex(comments, { id: item.id });

        if (updateIndex >= 0) {
          comments.splice(updateIndex, 1, {
            ...comments[updateIndex],
            ...item,
          });
        } else {
          comments.push(item);
        }
      }

      return {
        ...state,
        comments: comments,
      };

    case 'SET_FILES_COMMENTS':
      return {
        ...state,
        comments: action.comments,
      };

    case 'UPDATE_FILES_FILTERS_RESET':
      return {
        ...state,
        filters: initialState.filters,
      };

    case 'UPDATE_FILES_FILTERS_UPDATED':
      return {
        ...state,
        filters: {
          ...state.filters,
          isUpdated: action.boolean,
        },
      };

    case 'UPDATE_FILES_FILTERS':
      return {
        ...state,
        filters: {
          ...state.filters,
          isCleared: false,
          options: {
            ...state.filters.options,
            ...action.filters,
          },
        },
      };

    case 'UPDATE_FILES_SELECTED':
      return {
        ...state,
        selected: action.selected,
      };

    case 'UPDATE_FILES_LIST':
      return {
        ...state,
        list: action.list,
      };
    case 'UPDATE_FILES_COUNT':
      return {
        ...state,

        fileCount: action.count,
      };
    case 'INCREMENT_FILES_COUNT':
      return {
        ...state,

        fileCount: state.fileCount + 1,
      };

    case 'UPDATE_FILES_LIST_ITEMS':
      let list = state.list;

      for (const item of action.list) {
        const updateIndex = _.findIndex(list, { id: item.id });

        if (updateIndex >= 0) {
          list.splice(updateIndex, 1, { ...list[updateIndex], ...item });
        } else {
          list.push(item);
        }
      }

      return {
        ...state,
        list: list,
        selectedItems: list.filter((f) => f.isSelected),
      };

    case 'UPDATE_SELECTED_ITEMS':
      return {
        ...state,
        selectedItems: action.selectedItems,
      };

    case 'TOGGLE_SELECTED_IN_SELECTED_ITEMS': {
      const item = state.selectedItems.find((f) => f.id === action.file.id);

      if (item) {
        return {
          ...state,
          selectedItems: state.selectedItems.filter(
            (f) => f.id !== action.file.id
          ),
        };
      } else {
        return {
          ...state,
          selectedItems: [...state.selectedItems, action.file],
        };
      }
    }

    case 'RESET_SELECTED_ITEMS':
      return {
        ...state,
        list: [],
        selectedItems: [],
      };

    case 'REMOVE_FILES_LIST_ITEM':
      console.log(
        state.list.filter((f) => action.list.indexOf(f.id) === -1),
        action.list
      );
      return {
        ...state,
        list: state.list.filter((f) => action.list.indexOf(f.id) === -1),
      };

    case 'UPDATE_FILES_FOLDERS':
      let folders = state.folders;

      for (const item of action.folders) {
        const updateIndex = _.findIndex(folders, { id: item.id });

        if (updateIndex >= 0) {
          folders.splice(updateIndex, 1, { ...folders[updateIndex], ...item });
        } else {
          folders.push(item);
        }
      }

      console.log(action.folders);

      return {
        ...state,
        folders: folders,
      };

    case 'REMOVE_FILES_FOLDERS':
      return {
        ...state,
        folders: state.folders.filter(
          (f) => action.folders.indexOf(f.id) === -1
        ),
      };

    case 'SET_FILES_FOLDERS':
      return {
        ...state,
        folders: action.folders,
      };

    case 'SET_FILES_COMMENT':
      return {
        ...state,
        fileComment: action.comment,
      };

    case 'CLEAR_FILES_FOLDERS':
      return {
        ...state,
        folders: [],
      };

    case 'UPDATE_FILES_SUBFOLDERS':
      return {
        ...state,
        subfolders: { ...state.subfolders, ...action.subfolders },
      };

    case 'REMOVE_FILES_SUBFOLDERS':
      return {
        ...state,
        subfolders: {
          ...state.subfolders,
          [action.folderId]: state.subfolders[action.folderId].filter(
            (f) => action.subfolders.indexOf(f.id) === -1
          ),
        },
      };

    case 'SET_SELECTED_FOLDER':
      return {
        ...state,
        folder: action.folder,
      };
    case 'ENABLE_UPDATE_SELECTED_FOLDER':
      return {
        ...state,
        enableUpdate: action.enable,
      };
    case 'CLEAR_FILES_SUBFOLDERS':
      return {
        ...state,
        subfolders: [],
      };

    case 'UPDATE_FILES_ACTIVE_FOLDER':
      return {
        ...state,
        activeFolder: action.folder,
      };

    case 'UPDATE_FILES_SIDEBAR_ACTIVE':
      return {
        ...state,
        activeInSidebar: action.menu,
      };

    case 'RESET_FILES_SIDEBAR_ACTIVE':
      return {
        ...state,
        activeInSidebar: initialState.activeInSidebar,
      };

    case 'UPDATE_FILES_TEMP':
      let files = state.tempFiles.files;

      for (const item of action.files) {
        const updateIndex = _.findIndex(files, { id: item.id });

        if (updateIndex >= 0) {
          files.splice(updateIndex, 1, { ...files[updateIndex], ...item });
        } else {
          files.push(item);
        }
      }

      return {
        ...state,
        tempFiles: {
          ...state.tempFiles,
          ...(action.status ? { status: action.status } : {}),
          ...(action.cancelToken ? { cancelToken: action.cancelToken } : {}),
          files: files,
        },
      };

    case 'UPDATE_FILES_CLEAR_TEMP':
      return {
        ...state,
        tempFiles: { ...initialState.tempFiles, files: [] },
      };

    case 'UPDATE_FILES_MODAL':
      return {
        ...state,
        modal: {
          ...state.modal,
          [action.modal]: action.open,
        },
      };

    case 'UPDATE_FILES_ACCESS':
      return {
        ...state,
        access: {
          ...state.access,
          ...action.access,
        },
      };
    case 'LIBRARY_ACCESS':
      return {
        ...state,
        libraryAccess: action.access,
      };

    case 'UPDATE_FILES_ACTION_ITEM':
      return {
        ...state,
        actionItem: action.action,
      };
    case 'UPDATE_FILES_GENERAL':
      return {
        ...state,
        ...action.data,
      };
    case 'UPDATE_FILES_LIBRARY_ACCESSS':
      return {
        ...state,
        updateLibraryAccess: action.update,
      };
    case 'UPDATE_FILES_SELECTED_BREADCRUMB':
      return {
        ...state,
        selectedBreadcrumb: action.breadcrumb,
      };
    case 'SET_FILE_ACTION_COMMENTS': {
      return {
        ...state,
        Actions: {
          ...state.Actions,
          [action.action]: action.data,
        },
      };
    }

    case 'CLEAR_FILE_ACTION_COMMENTS': {
      return {
        ...state,
        Actions: {
          add: {},
          reply: {},
          update: {},
        },
      };
    }
    case 'FILES_TOGGLE_DELETE_MODAL_DISPLAY':
      return {
        ...state,
        showDeleteModal: !state.showDeleteModal,
      };

    case 'FILES_TOGGLE_DELETE_MODAL_DISPLAY_AND_SET_SELECTED':
      return {
        ...state,
        showDeleteModal: !state.showDeleteModal,
        selected: action.selected,
      };
    default:
      return state;
  }
}
